<template>
    <div class="mini-program-container">
        <Card>
            <div class="search-bar">
                <div class="filter">
                    <Select v-model="searchForm.minisType" placeholder="请选择小程序类型" clearable style="width: 150px">
                        <Option value="1" label="IAA" />
                        <Option value="2" label="IAP" />
                    </Select>
                </div>
                <div class="search-input-wrap">
                    <Input v-model="searchForm.keyword" clearable placeholder="搜索小程序名称、appid" @on-enter="handleSearch"
                        style="width: 150px" />
                    <Button type="primary"  @click="handleSearch">搜索</Button>
                    <Button  @click="handleReset">重置</Button>
                </div>
                <Button type="primary" icon="md-add" @click="handleAdd">新增小程序</Button>
            </div>

            <Table :data="tableData" :columns="columns" :loading="loading">
                <template slot="minisType" slot-scope="{ row }">
                    <span :class="['type-tag']">{{ row.minisType === 1 ? 'IAA' : 'IAP' }}</span>
                </template>
            </Table>

            <div class="pagination-wrap">
                <Pages :page="page" :func="handlePageChange" />
            </div>
        </Card>

        <Modal title="新增小程序" v-model="dialogVisible" width="500px" :top="100">
            <Form ref="form" :model="form" :rules="rules">
                <FormItem label="小程序名称" prop="minisName">
                    <Input v-model="form.minisName" placeholder="请输入小程序名称" />
                </FormItem>
                <FormItem label="appId" prop="appId">
                    <Input v-model="form.appId" type="number" placeholder="请输入appId" />
                </FormItem>
                <FormItem label="小程序app凭证key" prop="clientKey">
                    <Input v-model="form.clientKey" placeholder="请输入小程序app凭证key" />
                </FormItem>
                <FormItem label="小程序app凭证秘钥" prop="clientSecret">
                    <Input v-model="form.clientSecret" placeholder="请输入小程序app凭证秘钥" />
                </FormItem>
                <FormItem label="小程序类型" prop="minisType">
                    <Select v-model="form.minisType" placeholder="请选择小程序类型">
                        <Option value="1" label="IAA" />
                        <Option value="2" label="IAP" />
                    </Select>
                </FormItem>
                <FormItem label="是否自有小程序" prop="isOwn">
                    <RadioGroup v-model="form.isOwn">
                        <Radio :label="0">否</Radio>
                        <Radio :label="1">是</Radio>
                    </RadioGroup>
                    <div class="is-own-tip">仅自有小程序会自动同步历史已发布的短剧</div>
                </FormItem>
            </Form>
            <template slot="footer">
                <Button @click="dialogVisible = false">取消</Button>
                <Button type="primary" @click="handleSubmit">确定</Button>
            </template>
        </Modal>
    </div>
</template>
<script>
import Pages from '@/components/pages'
import { getMinisSetting, addMinisSetting } from '@/api/mini-program'
export default {
    name: 'MiniProgram',
    components: {
        Pages
    },
    data() {
        return {
            loading: false,
            searchForm: {
                minisType: '',
                keyword: ''
            },
            tableData: [],
            page: {
                current: 1,
                size: 10,
                total: 0
            },
            columns: [
                {
                    title: '小程序名称',
                    key: 'minisName',
                },
                {
                    title: 'appId',
                    key: 'appId',
                },
                {
                    title: '小程序类型',
                    slot: 'minisType',
                },
                {
                    title: '小程序app凭证key',
                    key: 'clientKey',
                },
                {
                    title: '小程序app凭证秘钥',
                    key: 'clientSecret',
                }
            ],
            dialogVisible: false,
            form: {
                minisName: '',
                appId: '',
                minisType: '',
                clientKey: '',
                clientSecret: '',
                isOwn: 1
            },
            rules: {
                minisName: [
                    { required: true, message: '请输入小程序名称', trigger: 'blur' }
                ],
                appId: [
                    { required: true, message: '请输入appId', trigger: 'blur' }
                ],
                minisType: [
                    { required: true, message: '请选择小程序类型', trigger: 'change' }
                ],
                clientKey: [
                    { required: true, message: '请输入小程序app凭证key', trigger: 'blur' }
                ],
                clientSecret: [
                    { required: true, message: '请输入小程序app凭证秘钥', trigger: 'blur' }
                ],
                isOwn: [
                    { required: true, type: 'number', message: '请选择是否自有小程序', trigger: 'change' }
                ]
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            let params = {}
            if( /^\d+$/.test(this.searchForm.keyword)) {
                params.appId = this.searchForm.keyword
            } else {
                params.minisName = this.searchForm.keyword
            }
            getMinisSetting({
                current: this.page.current,
                size: this.page.size,
                minisType: this.searchForm.minisType,
                ...params
            }).then((r) => {
                if (r.code === 200) {
                    this.tableData = r.data.data.records || []
                    this.page.total = r.data.data.total || 0
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleSearch() {
            this.page.current = 1
            this.getData()
        },
        handleReset() {
            this.searchForm = {
                minisType: '',
                keyword: ''
            }
            this.getData()
        },
        handlePageChange(page) {
            this.page.current = page || 1
            this.getData()
        },
        handleAdd() {
            this.form = {
                minisName: '',
                appId: '',
                minisType: '',
                clientKey: '',
                clientSecret: '',
                isOwn: 1
            }
            this.dialogVisible = true
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const formData = {
                        ...this.form,
                        minisType: Number(this.form.minisType),
                        isOwn: Number(this.form.isOwn)
                    }
                    addMinisSetting(formData).then((r) => {
                        if (r.code === 200) {
                            this.$Message.success('新增成功')
                            this.dialogVisible = false
                            this.getData()
                        }
                    }).catch(() => {
                        this.dialogVisible = false
                        this.$Message.error('新增失败')
                    }).finally(() => {
                        this.$refs.form.resetFields()
                    })
                } else {
                    this.$Message.error('请填写完整信息')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.mini-program-container {
    min-height: calc(100vh - 100px);
}

.search-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .search-input-wrap {
        display: flex;
        gap: 8px;
        flex: 1;
        min-width: 300px;

        :deep(.ivu-input) {
            flex: 1;
        }
    }
}

.pagination-wrap {
    margin-top: 16px;
    text-align: right;
}

.type-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;

    &.iap {
        background-color: #e6f7ff;
        color: #1890ff;
    }

    &.iaa {
        background-color: #f6ffed;
        color: #52c41a;
    }
}

.is-own-tip {
    margin-top: 2px;
    color: #999;
    font-size: 11px;
    line-height: 1.5;
}
</style>
